import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  public loading = new Subject<boolean>();
    
  constructor(private toast: ToastrService) {
      this.loading.next(false);
  }
  showSuccessToast(message) {
      this.toast.success(message, ' Success');
  }

  showErrorToast(message) {
      this.toast.error(message, 'Error ');
  }
}
